import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Grid, Typography, Box } from '@mui/material'
import { Formik } from 'formik'
import React from 'react'
import { FormStepProps } from 'src/Libs/installation-statement/components/types'
import { EdisonWallBoxForm } from 'src/Libs/installation-statement/components/EdisonWallbox/index'
import { EdisonWallBoxFormData } from 'src/Libs/installation-statement/models/edisonWallBox'
import { buildLabelWithRequiredPrefix } from 'src/Libs/form'
import useEdisonValidation from 'src/Libs/installation-statement/hooks/validation/use-edison-validation'

/**
 * Component for displaying the Edison step wrapper
 */
const EdisonWallBox: React.FC<FormStepProps<EdisonWallBoxFormData>> = ({ data, setFormData, setTouched, setFinalValidation }) => {
  const { t } = useCustomTranslation()
  const { inProgressValidationSchema, finalValidationSchema } = useEdisonValidation()

  const handleValidationForFinalValidationSchema = async (values: EdisonWallBoxFormData): Promise<void> => {
    const response = await finalValidationSchema.isValid(values)
    setFinalValidation(response)
  }

  return (
    <Grid container sx={{ flexDirection: 'column' }} spacing={0}>
      <Typography variant="h4" sx={{ mb: 2 }}>
        {t('installation-statement.edison.title-capitalized')}
      </Typography>
      <Formik
        initialValues={data}
        onSubmit={() => {
          /* */
        }}
        isInitialValid={false}
        validationSchema={inProgressValidationSchema}
      >
        {formData => {
          if (formData.dirty) {
            setTouched(true)
          }

          setFormData(formData)

          handleValidationForFinalValidationSchema(formData.values)
          return <EdisonWallBoxForm />
        }}
      </Formik>
      <Box sx={{ display: 'flex', justifyContent: 'end', marginTop: 2 }}>
        <Typography variant="caption">{buildLabelWithRequiredPrefix(t('common.required'))}</Typography>
      </Box>
    </Grid>
  )
}

export default EdisonWallBox
